module.exports = __webpack_public_path__ + "static/media/earth-env.c7c024eb.jpg";